import { axiosInstance } from 'network/apis';

export const fetchIncentiveUpdateReasons = async () => {
  return await axiosInstance.get('MyProxy/hono-value-update-reason-list', { handlerEnabled: true });
};

export const updateIncentive = async (data) => {
  return await axiosInstance.post('MyProxy/time-slot-custom-hono', data, { handlerEnabled: true });
};

export default {
  fetchIncentiveUpdateReasons,
  updateIncentive
}